import styled from 'styled-components';

export default styled.input`
  display: none
`;
